import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import cn from 'classnames';

import t from '../../lib/I18n';
import Favourite from "../../records/Favourite";
import FeatureFlagStore from "../../stores/FeatureFlagStore";

import FavouriteDetails from './FavouriteDetails';
import OnEnterTrigger from '../general/OnEnterTrigger';

export default function FavouriteListItem ({ favourite, onSelect, onDelete }) {
    const selectFavourite = () => onSelect(favourite);
    const deleteFavourite = () => onDelete(favourite);

    const permitChanges = FeatureFlagStore.get('enableFavouriteTicketChanges');
    const descriptionClasses = cn('favourite-list__item__description', {
        'favourite-list__item__description--full-width': !permitChanges,
    });

    return (
        <li className="favourite-list__item">
            <OnEnterTrigger className={descriptionClasses} title={ t('button.text.select') } tabIndex="0" role="button" onClick={ selectFavourite }>
                <FavouriteDetails favourite={favourite} />
            </OnEnterTrigger>
            {permitChanges && <OnEnterTrigger className="favourite-list__item__action" title={ t('button.text.delete') } tabIndex="0" role="button" onClick={ deleteFavourite }/>}
        </li>
    );
}

FavouriteListItem.propTypes = {
    favourite: PropTypes.instanceOf(Favourite).isRequired,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func
};

FavouriteListItem.defaultProps = {
    onSelect: _.noop,
    onDelete: _.noop
};



// WEBPACK FOOTER //
// ./src/components/favourites/FavouriteListItem.js